'use client';

import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';
import {useCallback} from 'react';

export function createQueryString(queryObj: Record<string, string | number | boolean>) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(queryObj)) {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value.toString());
    }
  }
  return params.toString();
}

export default function useQueryParam(pathname: string = '/') {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const updateQueryParams = useCallback((key: string, value: string | number | boolean) => {
    const newParams = new URLSearchParams(searchParams);
    if (!value) {
      newParams.delete(key);
    } else {
      newParams.set(key, value.toString());
    }
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  const clearQueryParam = useCallback((keys: string[]) => {
    const newParams = new URLSearchParams(searchParams);
    keys.forEach(key => newParams.delete(key));
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  const getParams = useCallback(() => {
    const params: Record<string, string | string[]> = {};
    searchParams.forEach((value, key) => {
      if (value.includes(',')) {
        params[key] = value.split(',');
      } else {
        params[key] = value;
      }
    });
    return params;
  }, [searchParams]);

  return {
    query: searchParams.toString(),
    loading: false,
    getParams,
    updateQueryParams,
    clearQueryParam,
    searchParams,
  };
}
